import React from 'react';
import classNames from 'classnames';
import styles from './PageBody.module.scss';

type PaddingSize = 'none' | 'small' | 'middle' | 'large';

interface Props {
  children: React.ReactNode | React.ReactNode[];
  className?: string;
  withSteps?: boolean;
  withoutHeader?: boolean;
  paddingTop?: PaddingSize;
  paddingBottom?: PaddingSize;
}

function PageBody(props: Props) {
  const {
    children,
    className,
    withSteps,
    withoutHeader,
    paddingTop = 'none',
    paddingBottom = 'large',
  } = props;
  return (
    <div
      className={classNames(
        styles.root,
        {
          [styles.withoutHeader]: withoutHeader,
          [styles.withSteps]: withSteps,
          [styles.pTopNone]: paddingTop === 'none',
          [styles.pBottomNone]: paddingBottom === 'none',
          [styles.pTopSmall]: paddingTop === 'small',
          [styles.pBottomSmall]: paddingBottom === 'small',
          [styles.pTopMiddle]: paddingTop === 'middle',
          [styles.pBottomMiddle]: paddingBottom === 'middle',
          [styles.pTopLarge]: paddingTop === 'large',
          [styles.pBottomLarge]: paddingBottom === 'large',
        },
        className,
      )}
    >
      {Array.isArray(children) ? children.map((child) => child) : children}
    </div>
  );
}

export default PageBody;
